import { SVGProps } from 'react';

export const LeftArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M1.87607 3.52873C1.58674 3.1834 1.2834 2.88473 0.966071 2.63273C0.65807 2.38073 0.33607 2.17073 7.04527e-05 2.00273V1.52673C0.67207 1.19073 1.2974 0.682067 1.87607 0.000734031H2.73007C2.60874 0.280734 2.47807 0.542067 2.33807 0.784734C2.19807 1.0274 2.0534 1.24207 1.90407 1.42873V2.10073C2.0534 2.2874 2.1934 2.50207 2.32407 2.74473C2.46407 2.97807 2.5994 3.2394 2.73007 3.52873H1.87607ZM1.82007 2.24073L1.83407 1.28873H9.74407V2.24073H1.82007Z"
      />
    </svg>
  );
};
